module.exports = __webpack_public_path__ + "img/helpPatients.6be3123e.svg";